<ion-content>
  <main>
    <img src="assets/images/update.svg" alt="Live update" class="live_update_img" />
    <ion-progress-bar [value]="progressPercent/100" class="progress-bar"></ion-progress-bar>
    <h1 class="wg-h-md">{{'AppUpdate.liveUpdateTitle' | translate}}</h1>
    <p class="body2">{{'AppUpdate.liveUpdateDescription' | translate}}</p>
  </main>
</ion-content>

<ion-footer class="ion-text-center ion-no-border" mode="ios">
  <p class="version">v{{version}}</p>
</ion-footer>
